<script lang="ts">
  let { sub = false } = $props();
</script>

<div class="form-group" class:subfield={sub}>
  <slot />
</div>

<style>
  .form-group:last-child {
    border-bottom: none;
  }
  .subfield {
    margin-left: 2.3em;
    border-bottom: none;
  }
</style>
